import axios from "axios";
import JSZip from "jszip";
import Papa from "papaparse";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import $ from "jquery"
import { API_BASE, downloadURL, IMAGE_URL, STUDENT_FILE_DOWNLOAD } from "../../utils/Constants";
import { RenderQuizResult } from '../../utils/CommonStatusItems';
import { convertToPlain } from "./Helper";
import { twoDecimalRound } from "../../utils/commonFunction";
import { DownloadAssessmentsStudentResults } from "../../services/CourseService";
import axiosInstance from "../../utils/axios";
import { getToken } from "../../utils/Auth";
import streamSaver, { createWriteStream } from 'streamsaver';
import Swal from "sweetalert2";
streamSaver.mitm = `${window.location.origin}/streamsaver/mitm.html`;
function calculateFileSize(data, maxSizePerArray) {
    let totalSize = 0;
    let urlArray = [];
    let checkTotal = 0;
    let urlArrays = [[]]; // Start with one empty array
    let currentArrayIndex = 0;
    let currentArraySize = 0;

    function addToCurrentArray(path, size, fileName, currentSize, inExamWarning) {
        const urlInfo = {
            path: path,
            size: size,
            loaded_Size: 0,
            flname: fileName,
            inExamWarning: inExamWarning,
        };
        urlArrays[currentArrayIndex].push(urlInfo);
        urlArray.push(urlInfo);
        currentArraySize += currentSize;
    }

    for (const item of data) {
        if (currentArraySize > maxSizePerArray) {
            currentArrayIndex++;
            urlArrays.push([]);
            currentArraySize = 0;
        }

        if (item.multipleFiles && item.multipleFiles.length) {
            for (const file of item.multipleFiles) {
                checkTotal++;
                const size = parseFloat(file.size);
                if (!isNaN(size)) {
                    totalSize += size;
                    if (currentArraySize + size <= maxSizePerArray) {
                        addToCurrentArray(file.path, file.size, item.flname, size);
                    } else {
                        currentArrayIndex++;
                        urlArrays.push([]);
                        currentArraySize = 0;
                        addToCurrentArray(file.path, file.size, item.flname, size);
                    }
                    urlArray.push({ path: file.path, size: file.size, loaded_Size: 0, flname: item.flname });
                } else {
                    addToCurrentArray(file.path, file.size, item.flname, size, file.inExamWarning);
                }
            }
        } else {
            if (item.path && item.path.trim() !== "") {
                checkTotal++;
                const size = parseFloat(item.size);
                if (!isNaN(size)) {
                    totalSize += size;
                    if (currentArraySize + size <= maxSizePerArray) {
                        addToCurrentArray(item.path, item.size, item.flname, size);
                    } else {
                        currentArrayIndex++;
                        urlArrays.push([]);
                        currentArraySize = 0;
                        addToCurrentArray(item.path, item.size, item.flname, size);
                    }
                    urlArray.push({ path: item.path, size: item.size, loaded_Size: 0, flname: item.flname });
                }
            }
            if (item.return && item.return.trim() !== "") {
                checkTotal++;
                const size = parseFloat(item.return_size);
                if (!isNaN(size)) {
                    totalSize += size;
                    if (currentArraySize + size <= maxSizePerArray) {
                        addToCurrentArray(item.return, item.return_size, item.flname, size);
                    } else {
                        currentArrayIndex++;
                        urlArrays.push([]);
                        currentArraySize = 0;
                        addToCurrentArray(item.return, item.return_size, item.flname, size);
                    }
                    urlArray.push({ path: item.return, size: item.return_size, loaded_Size: 0, flname: item.flname });
                }
            }
        }

        if (item.quizSubmitedDocs && item.quizSubmitedDocs.length) {
            for (const file of item.quizSubmitedDocs) {
                checkTotal++;
                const size = 0;
                // if (isNaN(size)) {
                    urlArrays[currentArrayIndex].push({
                        path: file.docs,
                        size: 0,
                        loaded_Size: 0,
                        flname: item.flname,
                    });
                    urlArray.push({ path: file.docs, size: 0, loaded_Size: 0, flname: item.flname });
                // }
            }
        }
    }

    return {
        totalSize, urlArray, checkTotal, urlArrays
    };
}

const MAX_CONCURRENT_DOWNLOADS = 5;

// export const handleDownloadAssessment = async (downloadZip, zipfilename, setCheckTotal, setCheckPending, setFinalTotal, setFinalLoadedData, setLoaded, setTotal, setTotalSize, isHybrid) => {
//     try {
//         let data = downloadZip;
//         let demoData = downloadZip;
//         const header = ["ROW", "SID", "CID", "STUDENT", "SURNAME", "ASSIGNMENT", "ASSESSMENT NAME", "HIGHEST MARK ACHIEVABLE", "MARKED ACHIEVED"];

//         data = data?.map((row) => ({
//             ...row,
//             ROW: row?.id ? row?.id : "",
//             CID: row.intake ? row.intake : "",
//             SID: row?.student ? row?.student : "",
//             STUDENT: row?.flname ? row?.flname : "",
//             SURNAME: row?.lname ? row?.lname : "",
//             ASSIGNMENT: row?.crm_id ? row?.crm_id : "",
//             // TOTALMARK: row?.assignment ? row?.assignment : "-",
//             "ASSESSMENT NAME": zipfilename ? zipfilename.trim() : "",
//             "HIGHEST MARK ACHIEVABLE": row.ass_total_mark >= 0 ? row.ass_total_mark : "",
//             // ATTACHMENT: row?.ass_weighting.toString() ? row?.ass_weighting.toString() == "0" ? "0" : row?.ass_weighting : "-",
//             // "MARKED ACHIEVED": row.ass_mark ?  row.ass_mark : "-",
//             // REMARK: row.path || row.return ? `${row.path ? row.path : ""} ${row.return ? row.return : ""}` : "",
//             "MARKED ACHIEVED": (row.ass_mark != null && row.ass_mark.toString() && row?.grade != 1) ? row.ass_mark
//                 : (row?.mark != null && row?.mark.toString() && row?.grade == 1 && row?.mark.toString().replace(/%\s?/g, '') >= 49) ? "Green"
//                     : (row?.mark != null && row?.mark.toString() && row?.grade == 1 && row?.mark.toString().replace(/%\s?/g, '') <= 49)
//                         && (row?.mark.toString() && row?.grade == 1 && row?.mark.toString().replace(/%\s?/g, '') >= 0) ? "Yellow"
//                         : row?.mark != null && row?.mark.toString() && row?.grade == 1 && row?.mark.toString().replace(/%\s?/g, '') <= 0 ? "Red" : "",
//         }));

//         let pending = 0;
//         const maxSizePerArray = 1324 * 1024 * 1024;
//         let fileDetails = calculateFileSize(demoData, maxSizePerArray);
//         setCheckTotal(fileDetails.checkTotal);
//         setTotalSize(fileDetails.totalSize.toFixed(1));
//         setFinalTotal(fileDetails.totalSize.toFixed(1))
//         let loadedArr = JSON.parse(JSON.stringify(fileDetails.urlArrays))

//         let zipPromises = [];
//         for (let i = 0; i < fileDetails.urlArrays.length; i += MAX_CONCURRENT_DOWNLOADS) {
//             const batch = fileDetails.urlArrays.slice(i, i + MAX_CONCURRENT_DOWNLOADS);
//             const batchPromises = batch.map(async (urlArray, index) => {
//                 let zip = new JSZip();
//                 let sizeArr = Array(urlArray.length).fill(0);
//                 let loadedBytes = 0;

//                 let promise = Promise.all(
//                     urlArray.map(async (row, rowIndex) => {
//                         const fileExt = (row.path.split("/").reverse()[0]).trim().replace(/[\t\r\n]/g, '');
//                         let fileURL = downloadURL + `${row.path.includes("s3.af-south-1.amazonaws.com") ? "" : STUDENT_FILE_DOWNLOAD.replace("https://", "") + "/"}${encodeURI(row.path.replaceAll(
//                             "/home/myaie/public_html/", "").replace("public/", ""))}`;
//                         if (isHybrid === true) {
//                             fileURL = downloadURL + STUDENT_FILE_DOWNLOAD.replace("https://", "") + `/${encodeURI(row.path.replaceAll(
//                                 "/home/myaie/public_html/", "").replace("public/", ""))}`;
//                         }
//                         let loadedFromArr = 0
//                         try {
//                             const resp = await axios({
//                                 url: fileURL,
//                                 method: 'get',
//                                 responseType: 'blob',
//                                 onDownloadProgress: (progressEvent) => {
//                                     const { loaded, total } = progressEvent;
//                                     loadedArr[index][rowIndex] = loaded
//                                     loadedFromArr = 0
//                                     loadedArr.map(item => item.map(subItem => {
//                                         if (typeof subItem === "number") {
//                                             loadedFromArr = loadedFromArr + subItem
//                                         }
//                                     }))
//                                     loadedBytes = loaded;
//                                     if (fileDetails.totalSize > loadedFromArr) {
//                                         setFinalLoadedData(loadedFromArr)
//                                     } else {
//                                         setFinalLoadedData(fileDetails.totalSize)
//                                     }
//                                 }
//                             });

//                             // code to create exam warning folder ----------------------------
//                             let zipFolder = zip.folder(`${row.flname + "_" + zipfilename.trim().replace(/[\t\r\n]/g, '')}`)
//                             let newUrlArr = urlArray.filter(item => row.flname == item.flname)

//                             let isFolderNeeded = false;
//                             for (let d of newUrlArr) {
//                                 if (d?.inExamWarning) {
//                                     isFolderNeeded = true;
//                                 }
//                             }
//                             let warningsFolder = ''
//                             // Create the warnings folder in the zip
//                             if (isFolderNeeded) {
//                                 warningsFolder = zipFolder.folder("Exam Warnings");
//                             }

//                             if (row?.inExamWarning) {
//                                 warningsFolder.file(`${fileExt}`, resp.data, { binary: true });
//                             } else {
//                                 zipFolder.file(`${fileExt}`, resp.data, { binary: true });
//                             }

//                             //---------------------------------------------------
//                             pending++;
//                             setCheckPending(pending);
//                         } catch (err) {
//                             console.error(err, "zip generation error")
//                             pending++;
//                             setCheckPending(pending);
//                         }
//                     })
//                 );

//                 promise = promise.then(() => {
//                     const textFileData = data.filter((item) => item.dataAns);
//                     if (textFileData.length) {
//                         textFileData.map((row) => {
//                             let fileContent = ""
//                             if (Array.isArray(row.dataAns) && row.dataAns.length) {
//                                 row.dataAns.map((element) => {
//                                     fileContent += "Question : " + element.questionName + "Answer : " + element.UserAnswer + "\n" + "\n";
//                                 })
//                             }
//                             if (fileContent != "") {
//                                 zip.folder(`${row.flname + "_" + zipfilename.trim().replace(/[\t\r\n]/g, '')}`).file("question.txt", fileContent);
//                             }
//                         })
//                     }
//                     const csvString = Papa.unparse({ fields: header, data });
//                     zip.file(`${zipfilename + "_" + index + 1 + ".csv"}`, csvString);
//                     return zip.generateAsync({ type: "blob" });
//                 });

//                 try {
//                     const zipBlob = await promise;
//                     const zipFileName = `${zipfilename}_${i / MAX_CONCURRENT_DOWNLOADS + index + 1}_.zip`;
//                     saveAs(zipBlob, zipFileName);
//                 } catch (err) {
//                     console.error("Error generating or downloading zip files:", err);
//                 }
//             });
//             zipPromises.push(Promise.all(batchPromises));
//         }

//         await Promise.all(zipPromises);

//         setTimeout(() => {
//             $("#downloadAssessment").modal("hide");
//             setCheckPending(0);
//             setCheckTotal(0);
//             setLoaded(0);
//             setTotal(0);
//             setFinalLoadedData(0);
//             setFinalTotal(0);
//         }, 1000);

//     } catch (error) {
//         console.error("Error generating or downloading zip files:", error);
//     } finally {
//         setCheckPending(0);
//         setCheckTotal(0);
//         setLoaded(0);
//         setTotal(0);
//         setFinalLoadedData(0);
//         setFinalTotal(0);
//         setTimeout(() => {
//             $("#downloadAssessment").modal("hide");
//         }, 1000);
//     }
// };

export const handleDownloadResults = async (downloadZip, zipfilename, setFinalTotal, setFinalLoadedData, setDownloading, subId, isHybrid) => {
    try {
        setDownloading(true);
        const parameter = { assignment: subId };
        const res = await DownloadAssessmentsStudentResults(parameter);

        if (res.status === 200) {
            let respData = res.data.data;
            let data1 = downloadZip;
            let demoData = downloadZip;
            const header = [
                "Student Number",
                "Student Name",
                "Final Mark",
                "Question Name",
                "Question",
                "Student Answer",
                "Correct Answer",
                "Mark",
                "Result",
            ];

            const formatData = [];

            respData.map((data) => {
                let dataItem = {
                    "Student Number": data.student_crm_id,
                    "Student Name": `${data.first_name} ${data.last_name}`,
                    "Final Mark": `${data.ass_mark}/${data.ass_total_mark}`,
                    "Question Name": "",
                    "Question": "",
                    "Student Answer": "",
                    "Correct Answer": "",
                    "Mark": "",
                    "Result": "",
                }
                formatData.push(dataItem)
                data.result && data.result.dataAns && data.result.dataAns.map((quesData, index) => {
                    if (quesData.questionType != "Document Upload" && quesData.questionType != "Long Answer") {
                        let subDataItem = {
                            "Student Number": "",
                            "Student Name": "",
                            "Final Mark": "",
                            "Question Name": quesData.question_name.length < 32000 ? quesData.question_name : "Data length is too large",
                            "Question": quesData.question ? (convertToPlain(quesData.question).length < 32000 ? convertToPlain(quesData.question) : "Data length is too large") : "NA",
                            "Student Answer": convertToPlain(quesData.UserAnswer).length < 32000 ? convertToPlain(quesData.UserAnswer) : "Data length is too large",
                            "Correct Answer": convertToPlain(quesData.correctAnswer).length < 32000 ? convertToPlain(quesData.correctAnswer) : "Data length is too large",
                            "Mark": `${twoDecimalRound(data.result.scoreArray[index])}/${twoDecimalRound(data.result.total_score_individual[index])}`,
                            "Result": (data.result?.total_score_individual ? data.result?.total_score_individual[index] == 0 : data.result?.scoreArray[index] == 0) ? RenderQuizResult("0").text
                                : data.result?.scoreArray[index] == 0 ? RenderQuizResult("0").text : (quesData.questionType == "Multiple Choice Multiple Answer" || quesData.questionType == "Match the Column")
                                    && (data.result?.total_score_individual ? data.result.scoreArray[index] / data.result?.total_score_individual[index] != 0 : data.result.scoreArray[index] / data.result.scoreArray[index] != 0)
                                    ? RenderQuizResult((data.result.scoreArray[index] / data.result?.total_score_individual[index]).toString()).text : parseInt(data.result.scoreArray[index]) == (data.result?.total_score_individual[index]
                                        ? data.result?.total_score_individual[index] : data.result.scoreArray[index]) ? RenderQuizResult("1").text : RenderQuizResult("0").text,
                        }
                        formatData.push(subDataItem);
                    }
                })
            });
            const compatibleData = formatData.map((row) => {
                const obj = {};
                header.forEach((col, index) => {
                    obj[col] = row[col];
                });
                return obj;
            });

            // Format data similar to handleDownloadAssessment
            data1 = data1 ? data1.map((row) => ({
                ...row,
                SID: row.student_crm_id ? row.student_crm_id : "",
                STUDENT: row.first_name ? `${row.first_name} ${row.last_name}` : "",
                SURNAME: row.last_name ? row.last_name : "",
                "ASSESSMENT NAME": zipfilename ? zipfilename.trim() : "",
                "HIGHEST MARK ACHIEVABLE": row.ass_total_mark >= 0 ? row.ass_total_mark : "",
                "MARKED ACHIEVED": row.ass_mark != null && row.ass_mark.toString() ? row.ass_mark : "",
                dataAns: row.result?.dataAns || []
            })) : [];

            const maxSizePerArray = 1536 * 1024 * 1024;
            let fileDetails = calculateFileSize(demoData, maxSizePerArray);
            setFinalTotal(fileDetails.totalSize.toFixed(1));
            let loadedArr = JSON.parse(JSON.stringify(fileDetails.urlArrays));

            let zipPromises = [];
            for (
                let i = 0;
                i < fileDetails.urlArrays.length;
                i += MAX_CONCURRENT_DOWNLOADS
            ) {
                const batch = fileDetails.urlArrays.slice(
                    i,
                    i + MAX_CONCURRENT_DOWNLOADS
                );
                const batchPromises = batch.map(async (urlArray, index) => {
                    let zip = new JSZip();
                    let sizeArr = Array(urlArray.length).fill(0);
                    let loadedBytes = 0;

                    let promise = Promise.all(
                        urlArray.map(async (row, rowIndex) => {
                            const fileExt = row.path
                                .split("/")
                                .reverse()[0]
                                .trim()
                                .replace(/[\t\r\n]/g, "");
                            let fileURL =
                                downloadURL +
                                `${row.path.includes("s3.af-south-1.amazonaws.com")
                                    ? ""
                                    : STUDENT_FILE_DOWNLOAD.replace("https://", "") + "/"
                                }${row.path
                                    .replaceAll("/home/myaie/public_html/", "")
                                    .replace("public/", "")}`;
                            if (isHybrid === true) {
                                fileURL =
                                    downloadURL +
                                    STUDENT_FILE_DOWNLOAD.replace("https://", "") +
                                    `/${row.path
                                        .replaceAll("/home/myaie/public_html/", "")
                                        .replace("public/", "")}`;
                            }
                            let loadedFromArr = 0;
                            try {
                                const resp = await axios({
                                    url: fileURL,
                                    method: "get",
                                    responseType: "blob",
                                    onDownloadProgress: (progressEvent) => {
                                        const { loaded, total } = progressEvent;
                                        loadedArr[index][rowIndex] = loaded;
                                        loadedFromArr = 0;
                                        loadedArr.map((item) =>
                                            item.map((subItem) => {
                                                if (typeof subItem === "number") {
                                                    loadedFromArr = loadedFromArr + subItem;
                                                }
                                            })
                                        );
                                        loadedBytes = loaded;
                                        if (fileDetails.totalSize > loadedFromArr) {
                                            setFinalLoadedData(loadedFromArr);
                                        } else {
                                            setFinalLoadedData(fileDetails.totalSize);
                                        }
                                    },
                                });

                                // Create student folder with exam warnings subfolder
                                let zipFolder = zip.folder(`${row.flname + "_" + zipfilename.trim().replace(/[\t\r\n]/g, '')}`);
                                let newUrlArr = urlArray.filter(item => row.flname == item.flname)

                                let isFolderNeeded = false;
                                for (let d of newUrlArr) {
                                    if (d?.inExamWarning) {
                                        isFolderNeeded = true;
                                    }
                                }
                                let warningsFolder = '';
                                // Create the warnings folder in the zip
                                if (isFolderNeeded) {
                                    warningsFolder = zipFolder.folder("Exam Warnings");
                                }

                                if (row?.inExamWarning) {
                                    warningsFolder.file(`${fileExt}`, resp.data, { binary: true });
                                }
                            } catch (err) {
                                console.log(err, "zip generation error");
                            }
                        })
                    );

                    promise = promise.then(() => {
                        // Add text files for question answers
                        const textFileData = data1.filter((item) => item.dataAns);
                        if (textFileData.length) {
                            textFileData.map((row) => {
                                let fileContent = "";
                                if (Array.isArray(row.dataAns) && row.dataAns.length) {
                                    row.dataAns.map((element) => {
                                        fileContent +=
                                            "Question : " +
                                            element.questionName +
                                            "Answer : " +
                                            element.UserAnswer +
                                            "\n" +
                                            "\n";
                                    });
                                }
                                if (fileContent != "") {
                                    zip
                                        .folder(
                                            `${row.flname +
                                            "_" +
                                            zipfilename.trim().replace(/[\t\r\n]/g, "")
                                            }`
                                        )
                                        .file("question.txt", fileContent);
                                }
                            });
                        }

                        // Generate XLSX file
                        let wb = XLSX.utils.book_new();
                        let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
                            header,
                        });
                        XLSX.utils.book_append_sheet(wb, ws1, "Results Data");
                        const xlsxBuffer = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });

                        zip.file(`${zipfilename + "_" + index + ".xlsx"}`, xlsxBuffer);

                        return zip.generateAsync({ type: "blob" });
                    });

                    try {
                        const zipBlob = await promise;
                        const zipFileName = `${zipfilename}_${i / MAX_CONCURRENT_DOWNLOADS + index + 1
                            }_.zip`;
                        saveAs(zipBlob, zipFileName);
                    } catch (err) {
                        console.error("Error generating or downloading zip files:", err);
                    }
                });
                zipPromises.push(Promise.all(batchPromises));
            }

            await Promise.all(zipPromises);
        }
    } catch (error) {
        console.error("Error generating or downloading zip files:", error);
    } finally {
        setTimeout(() => {
            $("#downloadAssessment").modal("hide");
            setFinalLoadedData(0);
            setFinalTotal(0);
            setDownloading(false);
        }, 1000);
    }
};

        

export async function createStudentSubmissionsZip(
    studentsData,
    zipName = 'student_submissions',
    includeSubfolders = true,
    setFinalLoadedData,
    setFinalTotal,
    dynamicKey
) {
    const zip = new JSZip();
    const mainFolder = zip.folder(zipName);
    let filesAdded = false;
    let fileDetails = {}
    let totalSize = 0;
    let key = "";
    let innerKey = "";
    let sizeKey = ""
    if(dynamicKey == "docs"){
        key = "answerdDocument"
        innerKey = "docs"
        sizeKey = "docs_size"
    }else{
        key = "studentEvidence"
        innerKey = "evidence_url"
        sizeKey = "evidence_size"
    }

    const fetchFileFromPath = async (filePath,sizeArr,index) => {
        let loadedFromArr = 0
        try {
            const url = `${downloadURL}${IMAGE_URL.replace("https://","")}/${filePath.replaceAll('/home/myaie/public_html/', '').replace('public/', '')}`;
            const response = await axios({
                url: url,
                method: 'get',
                responseType: 'blob',
                onDownloadProgress: (progressEvent) => {
                    const { loaded, total } = progressEvent;
                sizeArr[index] = loaded
                loadedFromArr = 0
                sizeArr.map(item => loadedFromArr = loadedFromArr + item)
                if(totalSize > loadedFromArr) {
                  setFinalLoadedData(loadedFromArr)
                }else{
                  setFinalLoadedData(totalSize)
                }
                }
            });
            return await response.data;
        } catch (error) {
            console.error(`Failed to fetch file ${filePath}:`, error);
            return null;
        }
    };
    let sizeArr = [];
    for(const student of studentsData) {
        if(student?.[key] && student?.[key]?.length == 0) continue;
        for (const data of student?.[key]) {
            sizeArr.push(0)
            const size = parseFloat(data?.[sizeKey]);
            if (!isNaN(size)) {
                totalSize += size;
            }
        }
    }

    setFinalTotal(totalSize.toFixed(2));   
     
    let index = 0;
    for (const student of studentsData) {
        if (!student?.[key]?.length) continue;
        
        const targetFolder = includeSubfolders
        ? mainFolder.folder(sanitizeFolderName(student.studentName))
        : mainFolder;
        
        const fileCountMap = {};
        // let sizeArr = Array(student??.[key]?.length).fill(0);
        
        for (let i = 0; i < student?.[key].length; i++) {
            index ++    
            const doc = student?.[key][i];
            if (!doc?.[innerKey]) continue;
            var loadedBytes = 0

            const fileBlob = await fetchFileFromPath(doc?.[innerKey],sizeArr,index);
            if (!fileBlob) continue;
            const originalName = doc?.[innerKey].split('/').pop() || `document_${i + 1}`;
            const [baseName, ext] = splitFilename(originalName);

            fileCountMap[originalName] = (fileCountMap[originalName] || 0) + 1;
            const count = fileCountMap[originalName];

            const uniqueName = count > 1
                ? `${baseName} (${count})${ext}`
                : originalName;

            targetFolder.file(uniqueName, fileBlob);
            filesAdded = true;
        }
    }

    if (filesAdded) {
        const content = await zip.generateAsync({ type: 'blob' });
        saveAs(content, `${zipName}.zip`);
        return true;
    }

    return false;
}


// Helper functions
function sanitizeFolderName(name) {
    return name.replace(/[\/\\:*?"<>|]/g, '_');
}

function splitFilename(filename) {
    const lastDot = filename.lastIndexOf('.');
    if (lastDot === -1) return [filename, ''];
    return [
        filename.substring(0, lastDot),
        filename.substring(lastDot)
    ];
}

const throttle = (func, limit) => {
    let lastFunc;
    let lastRan;
    return (...args) => {
        if (!lastRan) {
            func(...args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(() => {
                if (Date.now() - lastRan >= limit) {
                    func(...args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
};

export const handleDownloadAssessment = async (
    payload,
    setPendingSize,
    setTotalSize,
    downloadModalName,
    zipName = "student-submissions.zip",
    setIsDownloading,
    apiUrl="/downloadStudentSubmissions"
) => {
    try {
        setIsDownloading(true);
        const safeZipName = zipName.replace(/[^a-zA-Z0-9-_]/g, '_') + '.zip';

        // Get total file size
        const sizeRes = await axiosInstance().post(apiUrl, {
            ...payload,
            getSize: true,
        }).catch(() => {
            Swal.fire({ icon: "error", title: "Download Failed", text: "Failed to download.. try again" });
            $(`#${downloadModalName}`).modal("hide");
            setIsDownloading(false);
            setTotalSize(0);
            setPendingSize(0);
            return;
        });

        const totalFileSize = sizeRes.data.totalFileSize || 0;
        setTotalSize(totalFileSize);

        const throttledProgress = (() => {
            let lastCall = 0;
            return (loaded) => {
                const now = Date.now();
                if (now - lastCall >= 100) {
                    if (loaded < totalFileSize) {
                        setPendingSize(loaded);
                    } else {
                        setPendingSize(totalFileSize);
                    }
                    lastCall = now;
                }
            };
        })();

        const fileStream = createWriteStream(safeZipName, { size: totalFileSize });

        const response = await fetch(`${API_BASE}${apiUrl}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getToken()}` },
            body: JSON.stringify(payload),
        }).catch(() => {
            Swal.fire({ icon: "error", title: "Download Failed", text: "Failed to download.. try again" });
            $(`#${downloadModalName}`).modal("hide");
            setIsDownloading(false);
            setTotalSize(0);
            setPendingSize(0);
            return;
        });

        if (!response.ok) throw new Error('Network response was not ok');
        if (!response.body) throw new Error('No readable stream in response');

        const reader = response.body.getReader();
        const writer = fileStream.getWriter();
        let received = 0;

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            await writer.write(value);
            received += value.length;
            throttledProgress(received);
        }

        setPendingSize(totalFileSize);
        await new Promise(resolve => setTimeout(resolve, 100));
        await writer.close();

    } catch (error) {
        console.error("Download failed:", error);
        Swal.fire({ icon: "error", title: "Download Failed", text: "Failed to download.. try again" });
    } finally {
        $(`#${downloadModalName}`).modal("hide");
        setIsDownloading(false);
        setTotalSize(0);
        setPendingSize(0);
    }
};